(() => {
	angular.module('main').directive('animateNewTask', animateNewTask);

	animateNewTask.$inject = [];

	function animateNewTask() {
		return {
			restrict: 'A',
			scope: {},
			link(scope) {
				scope.$on('animateTask', animateNewTask);

				let counter = 0;
				const TOP_SPACE = 200;

				function animateNewTask(event, taskToAnimate) {
					if (counter > 30) return;

					const taskOffset = $(taskToAnimate).offset();
					if (!taskOffset) {
						counter += 1;
						setTimeout(() => {
							animateNewTask(event, taskToAnimate);
						}, 100);
					} else {
						$('html, body').animate(
							{
								scrollTop: taskOffset.top - TOP_SPACE
							},
							1500,
							() => {
								const animationClass = 'animated tada';
								$(taskToAnimate).addClass(animationClass);
							}
						);
					}
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Workflow/animateNewTask.js